@let filesCollection = filesEc;
@let management = filesCollection.management;
@let managementSelectors = management.selectors;
@let agents = managementSelectors.agents.asSignal();
@let agentItems = getAgentItems(agents);
@let selectedAgentId = managementSelectors.selectedAgentId.asSignal();
@let selectedAgent = managementSelectors.selectedAgent.asSignal();
@let showDataSourceSelector =
  managementSelectors.showDataSourceSelector.asSignal();
@let dataSourceItems = getDataSourceItems(selectedAgent);
@let selectedDataSource = managementSelectors.selectedDataSource.asSignal();
@let isAgentMode = managementSelectors.isAgentMode.asSignal();

<div class="atn-admin-knowledge-bases-agent-tab">
  <atn-ds-widget title="Knowledge-base source">
    <div class="atn-admin-knowledge-bases-agent-tab__selectors">
      <atn-ds-select-single
        label="Agent"
        [items]="agentItems"
        [required]="true"
        [value]="selectedAgentId"
        (valueChange)="
          management.actions.selectAgent
            .from('Admin.KnowledgeBases.Agent.Selected')
            .dispatch($event)
        "
      />

      @if (showDataSourceSelector) {
        <atn-ds-select-single
          label="Data source"
          [items]="dataSourceItems"
          [required]="true"
          [value]="selectedDataSource"
          (valueChange)="
            management.actions.selectDataSource
              .from('Admin.KnowledgeBases.DataSource.Selected')
              .dispatch($event)
          "
        />
      }
    </div>
  </atn-ds-widget>

  @if (isAgentMode && selectedDataSource) {
    <atn-admin-knowledge-bases-page-document-upload />

    <div class="atn-admin-knowledge-bases-agent-tab__documents">
      <atn-ds-table [config]="documentsTableConfig" />
    </div>
  }
</div>
